import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-restart-dialog',
  templateUrl: './restart-dialog.component.html',
  styleUrls: ['./restart-dialog.component.css']
})
export class RestartDialogComponent implements OnInit {

  constructor(translate: TranslateService) { }

  ngOnInit() {
  }

}
